import { calculateAge } from '../../utils/calculateAge';
import ListenVoice from '../ui/ListenVoice';

export function ProfileInformation({
  name,
  birthDay,
  city,
  country,
  purpose,
  audioMessage,
  interests,
  about,
  showHeader = true
}) {
  return (
    <>
      {showHeader && (
        <>
          <h1 className="font-raleway font-bold mt-6 text-white text-[26px] truncate">
            {name || 'Имя не указано'}
            {birthDay && `, ${calculateAge(birthDay)} лет`}
          </h1>
          <h1 className="font-raleway font-light mt-2 text-white text-[18px] truncate">
            {city || 'Город не указан'}, {country || 'Страна не указана'}
          </h1>
          <div className="border-b-2 border-white/30 pt-5" />
        </>
      )}
      <h1 className={`font-raleway font-bold text-white text-[18px] ${showHeader ? 'mt-6' : 'mt-0'}`}>
        Цель знакомства
      </h1>
      <h1 className="font-raleway font-light mt-2 text-white text-[18px] truncate">{purpose || 'Не указана'}</h1>
      {about && about.trim() && (
        <div className="mt-6">
          <h1 className="font-raleway font-bold text-white text-[18px]">О себе</h1>
          <h1 className="font-raleway font-light text-white text-[18px] [overflow-wrap:anywhere] mt-2">
            {about?.trim() || 'Не указано'}
          </h1>
        </div>
      )}
      <h1 className="font-raleway font-bold mt-6 text-white text-[18px]">Интересы</h1>
      <h1 className="font-raleway font-light mt-2 text-white text-[18px]">
        {interests && interests.length > 0 ? interests.join(', ') : 'Интересы не указаны'}
      </h1>
    </>
  );
}
